import React, { Component } from 'react'
import { connect } from 'react-redux'
import { RadioInput, ConfirmFields, Select, TextInput } from './Form'
import { DumbField } from '../Field'
import { getWebUserRecordByType } from '../WizardActions'
import { getValidityClass } from '../Field'
import ReactMarkdown from 'components/Markdown/Markdown'
import { MASK } from '../validate'
import {noop} from 'utilities'

const ADDITIONAL = {
  'trade': {
    label: 'Trade',
    optionsSrc: 'tradeNames'
  },
  'fictitious': {
    label: 'Fictitious',
    optionsSrc: 'fictitiousNames'
  }
}

const emptyOption = {value: '', label: '[Select an Option]'}

class EntityNameSearch extends Component{
  constructor(){
    super()
    this.state = {
      reservedNames: [],
      tradeNames: [],
      fictitiousNames: []
    }
  }
  componentDidMount = () => {
    if (this.props.isFirst) {
      try {
        this.focusTarget.focus()
      } catch (e) {
        console.warn('Attempted to focus unfocusable element', e)
      }
    }
    this.props.getWebUserRecordByType('RESERVED_NAME', reservedNames => {
      this.setState({
        reservedNames: (reservedNames && Array.isArray(reservedNames) ? reservedNames : []).map(
          name => ({
            value: name.SOURCE_ID,
            label: `${name.NAME}`,
            num: name.SOURCE_NUM,
            name: name.NAME
          })
        )
      })
    })
    this.props.getWebUserRecordByType('TRADE_NAME', tradeNames => {
      this.setState({
        tradeNames: (tradeNames && Array.isArray(tradeNames) ? tradeNames : []).map(name => ({
          value: name.SOURCE_ID,
          label: `${name.NAME}`,
          name: name.NAME
        }))
      })
    })
    this.props.getWebUserRecordByType('PARTNERSHIP_FICTITIOUS_NAME', ficNames => {
      this.setState({
        fictitiousNames: (ficNames && Array.isArray(ficNames) ? ficNames : []).map(name => ({
          value: name.SOURCE_ID,
          label: `${name.NAME}`,
          name: name.NAME
        }))
      })
    })
  }
  setAdditionalName = (value, e) => {
    const foundNameTrade = this.state.tradeNames.find(name=>name.value ==value);
    const additionalName = foundNameTrade ? foundNameTrade.name : ''
    this.props.onChange({...this.props.value, [e.target.name]: value , additionalName})
  }
  setFieldValueByName = (value, e) => {
    this.props.onChange({...this.props.value, [e.target.name]: value})
  }
  setReservedName = (reservedId, e) => {
    const foundName = this.state.reservedNames.find(name => name.value == reservedId)
    const reservedName = foundName ? foundName.name : ''
    const reservedNum = foundName ? foundName.num : ''
    this.props.onChange({
      ...this.props.value,
      [e.target.name]: reservedId,
      reservedName,
      reservedNum,
      ...(this.props.allowReservedNameEditing ? {
        val1: reservedName,
        val2: reservedName
      } : {})
    })
  }
  setAdditionalName = (value, e) => {
      const foundNameTrade = this.state[this.props.value.additionalMode+'Names'].find(name=>name.value ==value);
      const additionalName = foundNameTrade ? foundNameTrade.name : ''
        this.props.onChange({...this.props.value, [e.target.name]: value,additionalName})
  }
  setConfirmFieldsValue = (value, e) => {
    this.props.onChange({...this.props.value, ...value}, e)
  }
  // bubbleBlurEvent = (value, e) => {
  //   this.props.onBlur(this.props.value, e)
  // }
  getValidityClass = ruleId => {
    const errors = this.getErrors()
    return getValidityClass(errors[ruleId] ? errors[ruleId].isValid : null)
  }
  getErrorMessage = ruleId => {
    const errors = this.getErrors()
    return errors[ruleId] ? errors[ruleId].errorMessage : []
  }
  applyMaskByMaskId = (maskId, value, e) => {
    switch (maskId) {
      case 'onlyNumbers':
        this.setFieldValueByName(MASK.onlyNumbers(value), e)
        break;
    }
  }
  onBlur = (value, e, extraPayload, overrideSetValue, options) => {
    this.props.onBlur(this.props.value, e, extraPayload, overrideSetValue, options);
  }
  getErrors = () => (this.props.errorMessage ? this.props.errorMessage[0] ? this.props.errorMessage[0] : {} : {})
  reduceErrors = errors => {
    return errors.reduce((isValid, err) => {
      if(isValid === false) return isValid
      if(err) return err.isValid
      return isValid
    }, null)
  }
  render(){
    const {
    	value,
      errorMessage,
      hideReserved,
      reservedLabel,
      allowReservedNameEditing,
    	hideAdditionalName,
      additionalLabel,
    	additionalDescription,
      nameLabel,
      nameDescription,
      nameConfirmLabel,
      nameMatch,
      hideConsent,
      hideNumConsent,
      consentLabel,
      required,
      disabled,
      tradeOptionLabel1,
      tradeOptionLabel2,
      consentOptionLabel1,
      consentOptionLabel2,
      consentDescription,
      consentInstructions,
      nameWidth,
      infoMessage,
    } = this.props
    const additionalNameShown = !hideAdditionalName;
    const errors = errorMessage ? errorMessage[0] ? errorMessage[0] : {} : {};
    return(
      <div>
        {
          !hideReserved &&
          <DumbField label={reservedLabel} errorMessage={this.getErrorMessage('mustSelectReservedOption')} required={required}>
            <RadioInput
              label={reservedLabel}
              validityClass={this.getValidityClass('mustSelectReservedOption')}
              options={[
                {value: 'Y', label: 'Yes'},
                {value: 'N', label: 'No'}
              ]}
              value={value.reservedYN}
              name='reservedYN'
              fieldId='reservedYN'
              onChange={this.setFieldValueByName}
              ref={focusTarget => {this.focusTarget = focusTarget}}
              disabled={disabled}
            />
          </DumbField>
        }
        {
          value.reservedYN === 'Y' && !hideReserved &&
          <div>
            {/* <DumbField label='Search for a reserved name'>
              <SearchControl value={{}} metadata={{SEARCH_TYPE: 33}}/>
            </DumbField> */}
            <DumbField label='Select a reserved name' errorMessage={this.getErrorMessage('mustSelectReservedName')} required={required}>
              <Select
                validityClass={this.getValidityClass('mustSelectReservedName')}
                width='40%'
                onBlur={noop}
                options={[emptyOption, ...this.state.reservedNames]}
                onChange={this.setReservedName}
                value={value.reservedNameId}
                name='reservedNameId'
                disabled={disabled}
              />
            </DumbField>
          </div>
        }
        {
          (value.reservedYN === 'N' || hideReserved || (allowReservedNameEditing && value.reservedYN === 'Y')) &&
          <DumbField
            hideLabel
            errorMessage={[
              ...this.getErrorMessage('entityNameRequired'),
              ...this.getErrorMessage('entityValuesMatch'),
              ...this.getErrorMessage('entityNameNotTaken'),
              ...this.getErrorMessage('entityIsValidName')
            ]}
            infoMessage={infoMessage !== "" && infoMessage ? [
              infoMessage
            ] : ''}
          >
            <ConfirmFields
              isValid={
                this.reduceErrors([
                  errors.entityNameRequired,
                  errors.entityValuesMatch,
                  errors.entityNameNotTaken,
                  errors.entityIsValidName
                ])
              }
              label={nameLabel}
              confirmFieldLabel={nameConfirmLabel}
              description={nameDescription}
              value={value}
              match={nameMatch}
              width={nameWidth}
              onChange={this.setConfirmFieldsValue}
              onBlur={this.onBlur}
              required={required}
              disabled={disabled}
            />
          </DumbField>
        }
        {
          (value.reservedYN === 'N' || hideReserved) && additionalNameShown &&
          <DumbField
            label={additionalLabel}
            description={additionalDescription}
            errorMessage={this.getErrorMessage('mustSelectAdditionalOption')}
            required={required}
          >
            <RadioInput
              validityClass={this.getValidityClass('mustSelectAdditionalOption')}
              options={[
                {value: 'N', label: tradeOptionLabel1},
                {value: 'Y', label: tradeOptionLabel2}
              ]}
              value={value.additionalYN}
              name='additionalYN'
              onChange={this.setFieldValueByName}
              disabled={disabled}
            />
          </DumbField>
        }
        <div className='dependent-field'>
          {
            (value.reservedYN === 'N' || hideReserved) && value.additionalYN === 'Y' && additionalNameShown &&
            <DumbField label={`Select a ${ADDITIONAL[value.additionalMode].label.toLowerCase()} name`} errorMessage={this.getErrorMessage('mustSelectAdditionalName')} required={required}>
              <Select
                validityClass={this.getValidityClass('mustSelectAdditionalName')}
                width='40%'
                onBlur={noop}
                options={[emptyOption, ...this.state[ADDITIONAL[value.additionalMode].optionsSrc]]}
                onChange={this.setAdditionalName}
                name='additionalNameId'
                value={value.additionalNameId}
              />
            </DumbField>
          }
        </div>
        {
          (value.reservedYN === 'N' || hideReserved) && (value.additionalYN === 'N' || !additionalNameShown) && !hideConsent &&
          <DumbField
            className={additionalNameShown ? 'consent': ''}
            label={consentLabel}
            description={consentDescription}
            errorMessage={this.getErrorMessage('mustSelectConsentOption')}
            required={required}
          >
            <RadioInput
              validityClass={this.getValidityClass('mustSelectConsentOption')}
              options={[
                {value: 'N', label: consentOptionLabel1},
                {value: 'Y', label: consentOptionLabel2}
              ]}
              value={value.consentYN}
              name='consentYN'
              onChange={this.setFieldValueByName}
              disabled={disabled}
            />
          </DumbField>
        }
        <div className='dependent-field'>
          {
            (value.reservedYN === 'N' || hideReserved) && (value.additionalYN === 'N' || !additionalNameShown) && value.consentYN === 'Y' && !hideConsent && !hideNumConsent &&
              <div>
                <ReactMarkdown source={consentInstructions} className='markdown' />
                <DumbField
                  label="Number of consents"
                  className=''
                  description={`Enter the number of consents required.

If multiple Consents are needed, each Consent is to be counted as one Consent.  However, if the same holder is authorized to sign, these may be combined and counted as one Consent.`}
                  errorMessage={this.getErrorMessage('numConsentsRequired')}
                  required={required}
                >
                  <TextInput
                    validityClass={this.getValidityClass('numConsentsRequired')}
                    value={value.numConsents}
                    name="numConsents"
                    onChange={(value, e) => {this.applyMaskByMaskId('onlyNumbers', value, e)}}
                    onBlur={noop}
                    placeholder='(Enter number of consents required)'
                    width='40%'
                    disabled={disabled}
                  />
                </DumbField>
              </div>
          }
        </div>
      </div>
    )
  }
}
export default connect(
  null,
  {getWebUserRecordByType}
)(EntityNameSearch)



// WEBPACK FOOTER //
// ./src/components/Wizard2/fieldComponents/EntityNameSearch.js